import React from 'react';
import './Divider.scss';
export const Divider = () => {
  return <div className="divider"></div>;
};
